import Moves from './Moves';

export default Moves;
